/* istanbul ignore file */

import { i18n } from '@fs/zion-locale'
import streamSaver from 'streamsaver'

// NOTE: In order for the following to work for tests, a moduleNameMapper config was added to package.json
// https://github.com/adaltas/node-csv/issues/309#issuecomment-1005315810
import { stringify } from 'csv-stringify/browser/esm/sync' // eslint-disable-line import/no-unresolved

// point streamsaver to our self hosted mitm.html file
streamSaver.mitm = `${window.location.origin}/${i18n.language}${window.location.hostname !== 'localhost' ? '/records' : ''}/streamsaver/mitm.html`

export default class DownloadCsvConfig {
  static columns = []

  // encoder, fileStream, writer, and wroteFirstRow are used for downloadStream
  encoder = null

  fileStream = null

  writer = null

  wroteFirstRow = false

  hasErrored = false

  defaultArgs = {
    columns: this.constructor.columns || [],
    delimiter: ',',
    filename: this.constructor.filename || i18n.t('DownloadCsvConfig.defaultFilename', 'results'),
    rows: [],
    doDownloadStream: false,
  }

  constructor(args) {
    const options = { ...this.defaultArgs, ...args }
    this.columns = options.columns
    this.delimiter = options.delimiter
    this.filename = options.filename
    this.rows = options.rows
    this.doDownloadStream = options.doDownloadStream
  }

  get content() {
    try {
      return stringify(this.rows, { columns: this.columns, delimiter: this.delimiter, header: true })
    } catch (err) {
      throw new Error(err)
    }
  }

  // only call this function when lightyear_lightyearReact_downloadStream flag is on
  // you need to call this function before calling generateRowsWithStream
  initiateDownloadStream(filename = '') {
    if (this.doDownloadStream) {
      const resolvedFilename = filename || this.filename || 'results'
      this.filename = resolvedFilename
      this.encoder = new TextEncoder()
      this.fileStream = streamSaver.createWriteStream(`${resolvedFilename}.csv`)
      this.writer = this.fileStream.getWriter()
    }
  }

  // only call this function when lightyear_lightyearReact_downloadStream flag is on
  // call this function with the rowToAdd in the generateRows function
  async writeToDownloadStream(rowToAdd) {
    try {
      if (this.hasErrored) return
      let csvRowToAdd = ''
      // need to add the first row for the header
      if (!this.wroteFirstRow) {
        // \uFEFF is the BOM character to help Excel and other programs recognize UTF-8 encoding
        csvRowToAdd = `\uFEFF${stringify([rowToAdd], { columns: this.columns, delimiter: this.delimiter, header: true })}`
        this.wroteFirstRow = true
      } else {
        csvRowToAdd = stringify([rowToAdd], { columns: this.columns, delimiter: this.delimiter, header: false })
      }
      const uInt8 = this.encoder.encode(csvRowToAdd)
      await this.writer.write(uInt8)
    } catch (err) {
      this.hasErrored = true
      this.writer.abort()
      throw new Error(`Failed to write to download: ${err}`)
    }
  }

  download() {
    if (this.doDownloadStream) {
      this.writer.close()
    } else {
      const a = document.createElement('a')
      const blob = new Blob([`\uFEFF${this.content}`], { type: 'text/csv' })
      const csvUrl = URL.createObjectURL(blob)
      a.setAttribute('download', `${this.filename}.csv`)
      a.setAttribute('href', csvUrl)
      a.click()
      URL.revokeObjectURL(csvUrl)
    }
  }

  // NOTE: This method is meant to be implemented by child classes
  generateRows() { } // eslint-disable-line class-methods-use-this
}
